import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import RankingSection from "./components/RankingSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "韩国漫画大全",
  url: "https://mangaink.github.io/",
  description: "按题材分类整理韩国漫画推荐的门户网站，覆盖奇幻、校园、古风等专题。",
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "韩国漫画大全收录了哪些题材类型？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "本站按韩漫大全类型整理内容，目前开设奇幻、校园、古风三大核心专题，并在专题内持续补充同类佳作。",
      },
    },
    {
      "@type": "Question",
      name: "奇幻专题主要推荐什么样的作品？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "韩漫大全奇幻专题涵盖异世界冒险、魔法学院、龙族与重生、超能力生存游戏等设定，偏热血战斗与宏大世界观。",
      },
    },
  ],
};

function Home() {
  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([orgJsonLd, faqJsonLd]) }}
      />
      <Hero />
      <CategorySection />
      <FeaturedSection />
      <RankingSection />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
    </Layout>
  );
}

export default Home;